import { lazy } from "react"

import Homepage from "../pages/website/Home"

import VIPGuests from "@pages/website/VIPGuests"

const About = lazy(() => import("../pages/website/About"))
const Gallery = lazy(() => import("../pages/website/Gallery"))
const Testimonials = lazy(() => import("../pages/website/Testimonials"))
const Availability = lazy(() => import("../pages/website/Availability"))
const RenterGuidelines = lazy(() => import("../pages/website/RenterGuidelines"))
// const FamilyAndFriends = lazy(() => import("../pages/website/FamilyAndFriends"))

export const routesConfig = [
  {
    key: "home",
    // The homepage is assumed to be the index (empty slug)
    paths: { en: "", fr: "", es: "" },
    element: <Homepage />,
  },
  {
    key: "about",
    paths: { en: "about", fr: "a-propos", es: "acerca-de" },
    element: <About />,
  },
  {
    key: "gallery",
    paths: { en: "gallery", fr: "galerie", es: "galeria" },
    element: <Gallery />,
  },
  {
    key: "testimonials",
    paths: { en: "testimonials", fr: "temoignages", es: "testimonios" },
    element: <Testimonials />,
  },
  {
    key: "availability",
    paths: { en: "availability", fr: "disponibilite", es: "disponibilidad" },
    element: <Availability />,
  },
  // These routes are not linked in the main navigation
  // They are accessed via QR codes
  {
    key: "renter-guidelines",
    paths: { en: "renter-guidelines", fr: "guide-locataire", es: "guia-inquilino" },
    element: <RenterGuidelines />,
  },
  {
    key: "family-and-friends",
    paths: { en: "vip-guests", fr: "invites-vip", es: "invitados-vip" },
    element: <VIPGuests />,
  },
]

export default routesConfig
